<nb-card
  class="nb_card_pop_up full_pop_up"
  style="
    max-height: 80vh;
    margin: 30px auto;
    position: relative;
    width: 90vw;
    max-width: 1000px;
  "
>
  <nb-card-header style="color: #fff">
    <div class="title">🚀 Almost done!</div>
  </nb-card-header>

  <nb-card-body [formGroup]="UserInfoForm">
    <div class="container">
      <div i18n="InitialUserInfoHeader" class="initial-user-header text-center">
        🙏 Please tell us a bit about you.
      </div>

      <div class="form-group row smaller-row">
        <div class="col-sm-4 label-custom required-label">
          <span i18n="@@FirstName">First Name</span> *
        </div>
        <div class="col-sm-8">
          <input
            nbInput
            formControlName="firstName"
            required
            type="text"
            fullWidth
            shape="semi-round"
            i18n-placeholder="@@FirstName"
            placeholder="First Name"
          />
          <ngx-validation-message
            i18n-label="@@FirstName"
            label="First Name"
            [showRequired]="firstName?.errors?.required && firstName.touched"
            [showPattern]="firstName?.hasError('pattern')"
            min="1"
            max="200"
          ></ngx-validation-message>
        </div>
      </div>

      <div class="form-group row smaller-row">
        <div class="col-sm-4 label-custom required-label">
          <span i18n="@@LastName">Last Name</span> *
        </div>
        <div class="col-sm-8">
          <input
            nbInput
            formControlName="lastName"
            required
            type="text"
            fullWidth
            shape="semi-round"
            i18n-placeholder="@@LastName"
            placeholder="Last Name"
          />
          <ngx-validation-message
            i18n-label="@@LastName"
            label="Last Name"
            [showRequired]="lastName?.errors?.required && lastName.touched"
            [showPattern]="lastName?.hasError('pattern')"
            min="1"
            max="200"
          ></ngx-validation-message>
        </div>
      </div>

      <div class="form-group row smaller-row">
        <div class="col-sm-4 label-custom required-label">
          <span i18n="@@BusinessName">Business Name</span>
        </div>
        <div class="col-sm-8">
          <input
            nbInput
            formControlName="businessName"
            type="text"
            fullWidth
            shape="semi-round"
            i18n-placeholder="@@BusinessName"
            placeholder="Business Name"
          />
          <ngx-validation-message
            i18n-label="@@BusinessName"
            label="Business Name"
            [showRequired]="
              businessName?.errors?.required && businessName.touched
            "
            [showPattern]="businessName?.hasError('pattern')"
            min="1"
            max="200"
          ></ngx-validation-message>
        </div>
      </div>

      <div class="form-group row smaller-row">
        <div class="col-sm-4 label-custom required-label">
          <span i18n="@@PhoneNumber">Mobile Number</span> *
        </div>
        <div class="col-sm-8">
          <ngx-intl-tel-input
            [preferredCountries]="preferredCountries"
            [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true"
            [searchCountryFlag]="true"
            [searchCountryField]="[
              SearchCountryField.Iso2,
              SearchCountryField.Name
            ]"
            [selectFirstCountry]="false"
            [selectedCountryISO]="CountryISO.UnitedStates"
            [maxLength]="15"
            [numberFormat]="PhoneNumberFormat.International"
            [phoneValidation]="true"
            name="phoneNumber"
            formControlName="phoneNumber"
            shape="semi-round"
          ></ngx-intl-tel-input>
          <ngx-validation-message
            i18n-label="@@PhoneNumber"
            label="Mobile Number"
            [showRequired]="
              phoneNumber?.errors?.required && phoneNumber.touched
            "
            [showPattern]="
              !phoneNumber?.errors?.required &&
              phoneNumber?.invalid &&
              phoneNumber.touched
            "
            min="10"
            max="15"
          ></ngx-validation-message>
        </div>
      </div>

      <div class="form-group row smaller-row" formGroupName="address">
        <div class="col-sm-4 label-custom required-label">
          <span i18n="@@Country">Country</span> *
        </div>
        <div class="col-sm-8">
          <nb-select
            id="inputCountry"
            size="medium"
            i18n-placeholder="@@Country"
            placeholder="Country"
            fullWidth
            formControlName="country"
          >
            <nb-option value="United States of America"
              >United States of America</nb-option
            >
            <nb-option value="Canada">Canada</nb-option>
            <nb-option value="United Kingdom">United Kingdom</nb-option>
            <nb-option value="Australia">Australia</nb-option>
            <nb-option value="New Zealand">New Zealand</nb-option>
            <nb-option value="Other">Other</nb-option>
          </nb-select>
          <ngx-validation-message
            i18n-label="@@Country"
            label="Country"
            [showRequired]="country?.errors?.required && country.touched"
            [showMaxLength]="country?.hasError('maxlength')"
            minLength="3"
            maxLength="1024"
          ></ngx-validation-message>
        </div>
      </div>
      <!--
      <div class="form-group row smaller-row">
        <div class="col-sm-4 label-custom  required-label"><span i18n="@@BusinessType">Business Type</span> *</div>
        <div class="col-sm-8">
          <nb-select formControlName="businessType" fullWidth i18n-placeholder="@@BusinessType"
            placeholder="Business Type">
            <nb-option *ngFor="let item of UserInfoEnums.BusinessTypeValues | keyvalue" [value]="+item.key">
              {{item.value}}</nb-option>
          </nb-select>
          <ngx-validation-message i18n-label="@@BusinessType" label="Business Type"
            [showMin]="businessType?.errors?.min && businessType.touched"
            [showMax]="businessType?.errors?.max && businessType.touched"
            [showRequired]="businessType?.errors?.required && businessType.touched"></ngx-validation-message>
        </div>
      </div>

     <div class="form-group row smaller-row">
        <div class="col-sm-4 label-custom required-label"><span i18n="@@HowManyCustomersPerMonth">How many customers per
            month?</span> *</div>
        <div class="col-sm-8">
          <nb-select formControlName="customersPerMonth" fullWidth i18n-placeholder="@@CustomersPerMonth"
            placeholder="Customers per month">
            <nb-option *ngFor="let item of UserInfoEnums.CustomersPerMonth | keyvalue" [value]="+item.key">
              {{item.value}}</nb-option>
          </nb-select>
          <ngx-validation-message i18n-label="@@CustomersPerMonth" label="Customers per month"
            [showMin]="customersPerMonth?.errors?.min && customersPerMonth.touched"
            [showMax]="customersPerMonth?.errors?.max && customersPerMonth.touched"
            [showRequired]="customersPerMonth?.errors?.required && customersPerMonth.touched"></ngx-validation-message>
        </div>
      </div>-->

      <div class="form-group row mt-4">
        <button
          i18n="@@Submit"
          class="btn-circle btn-xl btn-main"
          nbButton
          
          [disabled]="!UserInfoForm.valid"
          (click)="save()"
        >
          Submit
        </button>
      </div>
    </div>
  </nb-card-body>
</nb-card>
